<ng-template wtfTemplateLoader [type]="0">
    <h1>String type</h1>
</ng-template>

<ng-template wtfTemplateLoader [type]="2">
    <h1>Boolean type</h1>
</ng-template>